// #region Input Ref Methods

export const MergeTagConstants = {
    Automation:"Automation",
    Messenger:"Messenger",
    AutomationTaskSubject:"AutomationTaskSubject",
 };

export function insertInInputField(
    ref: React.RefObject<HTMLInputElement>,
    data: string,
    target: string,
    setFieldValue: (field: string, value: any) => void,
    setFieldError: (field: string, message: string | undefined) => void,
    maxLength?: number
): void {
    if (!ref.current) return;

    const textFieldIndex = ref.current.selectionStart ?? null;
    if (textFieldIndex !== null) {
        const currentText = ref.current.value;
        const updatedText =
            currentText.slice(0, textFieldIndex) + data + currentText.slice(textFieldIndex);

        if (maxLength) {
            if (updatedText.length > maxLength) {
                setFieldError(target, `You’ve exceeded the maximum limit of ${maxLength} characters.`);
                return;
            } 
            // else if (errors[target]) {
            //     setFieldError(target, undefined);
            // }
        }

        setFieldValue(target, updatedText);
    }
}

export function OpenMergeTagsWindow(
    ref: React.RefObject<HTMLInputElement>,
    messageSnippet: string,
    target: string,
    setFieldValue: (field: string, value: any) => void,
    setFieldError: (field: string, message: string | undefined) => void,
    maxLength?: number
): void {
    insertInInputField(ref, messageSnippet, target, setFieldValue, setFieldError, maxLength);
    focusInputField(ref);
}

export function handleEmojiSelect(
    ref: React.RefObject<HTMLInputElement>,
    emoji: string,
    target: string,
    setFieldValue: (field: string, value: any) => void,
    setFieldError: (field: string, message: string | undefined) => void,
    maxLength?: number
): void {
    insertInInputField(ref, emoji, target, setFieldValue, setFieldError, maxLength);
    focusInputField(ref);
}

export function handleAddUrlShortner(
    ref: React.RefObject<HTMLInputElement>,
    shortner: string,
    target: string,
    setFieldValue: (field: string, value: any) => void,
    setFieldError: (field: string, message: string | undefined) => void,
    maxLength?: number
): void {
    insertInInputField(ref, shortner, target, setFieldValue, setFieldError, maxLength);
    focusInputField(ref);
}


function focusInputField(ref: React.RefObject<HTMLInputElement>): void {
    setTimeout(() => {
        if (ref.current) {
            ref.current.focus();
            ref.current.selectionStart = ref.current.value.length;
            ref.current.selectionEnd = ref.current.value.length;
        }
    }, 0);
}

// function insertInInputField(
//     ref: React.RefObject<HTMLInputElement>,
//     data: string,
//     target: string,
//     formik: any, 
//     maxLength?: number
//   ): void {
//     if (!ref.current) return;
  
//     const textFieldIndex = ref.current.selectionStart ?? null;
//     if (textFieldIndex !== null) {
//       const currentText = ref.current.value;
//       const updatedText = currentText.slice(0, textFieldIndex) + data + currentText.slice(textFieldIndex);
  
//       if (maxLength) {
//         if(updatedText.length > maxLength)
//         {
//             formik.setFieldError(target, `You’ve exceeded the maximum limit of ${maxLength} characters.`);
//             return;
//         }
//         else if (formik.errors[target]) 
//         {
//             formik.setFieldError(target, undefined);
//         }
//       } 
  
//       formik.setFieldValue(target, updatedText);
//     }
//   }
  

// function OpenMergeTagsWindow(ref: React.RefObject<HTMLInputElement>, messageSnippet: string, target: string, formik: any,  maxLength?: number): void {
//     insertInInputField(ref, messageSnippet, target, formik, maxLength);
//     focusInputField(ref);
// }

// function handleEmojiSelect(ref: React.RefObject<HTMLInputElement>, emoji: string, target: string,  formik: any, maxLength?: number): void {
//     insertInInputField(ref, emoji, target, formik, maxLength);
//     focusInputField(ref);
// }

// function handleAddUrlShortner(ref: React.RefObject<HTMLInputElement>, shortner: string, target: string, formik: any,  maxLength?: number): void {
//     insertInInputField(ref, shortner, target, formik, maxLength);
//     focusInputField(ref);
// }

// #endregion Input Ref Methods